module.exports = __webpack_public_path__ + "static/media/image6.53cd4acf.png";